import React, { useState, useContext, useEffect, useMemo, useCallback, useReducer } from 'react'
import { useTranslation } from "react-i18next";
import { GetAlertsComponent, setObjectByPath, validateConstantValues, translateType } from "./utils"
import AuthContext from '../../../../context/auth-context'
import axios from 'axios'
import { dataFetchReducer } from "../../../Utils/requestUtils"
import { trimNestedObject } from '../../../Utils/utils'
import TextField from "@material-ui/core/TextField";
import MenuItem from '@material-ui/core/MenuItem';
import RulesContext from "../../../../context/rules-context"
import _ from "lodash"
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import TimeDeltaTextField from './Components/TimeDeltaTextField';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material'
import {
    getRegionFromEnvironment,
    getEnvironmentFromRegion,
    FieldsManager,
    HistoricalDataPicker,
    getEventTypesIntersectionAcrossCompanies,
    RULE_PIECE_CURRENT_COMPANY_KEY,
    areFieldsCleared,
    RULE_PIECE_CURRENT_EVENT_ENUM,
    RULE_PIECE_CURRENT_EVENT_ES_INDEX,
    RULE_PIECE_CURRENT_EVENT_ENVIRONMENT,
    RULE_PIECE_CURRENT_EVENT_REGION,
    RULE_PIECE_CURRENT_EVENT_DATE_PATH
} from './EventFieldShared'

function isNodeV1Variability(node) {
    const properties = node?.node?.properties
    return (
        !Array.isArray(properties?.fields) &&
        Array.isArray(properties?.referenced_field_paths)
    )
}

function translateReferencesV1toV2Variability(referenced_field_paths) {
    const newFields = []
    if (Array.isArray(referenced_field_paths)) {
        referenced_field_paths.forEach((path) => {
            if (typeof path === "string" && path.trim() !== "") {
                newFields.push({
                    target_field_path: path,
                    value: path,
                    comparison: "equal",
                    type: "dynamic"
                })
            }
        })
    }
    return newFields
}

function nodeToV2Variability(node) {
    const properties = node?.node?.properties
    if (!isNodeV1Variability(node)) return node
    node.node.properties.fields = translateReferencesV1toV2Variability(properties?.referenced_field_paths)
    delete node.node.properties.referenced_field_paths
    delete node.node.properties.match_number
    return node
}

export function EventFieldVariabilityBox (props) {
    const { t } = useTranslation();
    let {node} = props
    let {read_only} = props
    let {handleConfigurationOpen} = props
    let {handleNodeRemove} = props
    let rulesList = useContext(RulesContext)
    const helperNode = _.cloneDeep(node)
    nodeToV2Variability(helperNode)
    const mappings = helperNode.node.properties.target_event_type?.field_mappings || rulesList.fields_mapper_list || []
    const variableField = mappings.filter(rule => rule.path === helperNode.node.properties.variable_field_path)[0]
    let referencedString = ""
    if (helperNode.node.properties.fields && helperNode.node.properties.fields.length > 0) {
        referencedString = helperNode.node.properties.fields.reduce((acc, field, idx, src) => {
            const mapping = mappings.filter(m => m.path === field.target_field_path)[0]
            const description = (mapping || { description: "" }).description
            if (idx === 0) acc = acc + description
            else if (idx === src.length - 1) acc = acc + " e " + description
            else acc = acc + ", " + description
            return acc
        }, "")
    }

    function getVisualPattern(value){
        let dateSplit = value.split("T")[0]

        let yearSplit = dateSplit.split("Y")
        let yearValue = ""
        if (yearSplit.length > 1){
            yearValue = yearSplit[0].replace(/\D/g, "");
            yearValue = /^0*$/.test(yearValue) ? "" :  yearValue + t(" Anos, ")
            dateSplit = yearSplit[1]
        }

        let monthSplit = dateSplit.split("M")
        let monthValue = ""
        if (monthSplit.length > 1){
            monthValue = monthSplit[0].replace(/\D/g, "");
            monthValue = /^0*$/.test(monthValue) ? "" :  monthValue + t(" Meses, ")
            dateSplit = monthSplit[1]
        }

        let weekSplit = dateSplit.split("W")
        let weekValue = ""
        if (weekSplit.length > 1){
            weekValue = weekSplit[0].replace(/\D/g, "");
            weekValue = /^0*$/.test(weekValue) ? "" :  weekValue + t(" Semanas, ")
            dateSplit = weekSplit[1]
        }

        let daySplit = dateSplit.split("D")
        let dayValue = ""
        if (daySplit.length > 1){
            dayValue = daySplit[0].replace(/\D/g, "");
            dayValue = /^0*$/.test(dayValue) ? "" :  dayValue + t(" Dias, ")
            dateSplit = daySplit[1]
        }

        let timeSplit = value.split("T").length > 1 ? value.split("T")[1] : ""

        let hourSplit = timeSplit.split("H")
        let hourValue = ""
        if (hourSplit.length > 1){
            hourValue = hourSplit[0].replace(/\D/g, "");
            hourValue = /^0*$/.test(hourValue) ? "" :  hourValue + t(" Horas, ")
            timeSplit = hourSplit[1]
        }
        let minuteSplit = timeSplit.split("M")
        let minuteValue = ""
        if (minuteSplit.length > 1){
            minuteValue = minuteSplit[0].replace(/\D/g, "");
            minuteValue = /^0*$/.test(minuteValue) ? "" :  minuteValue + t(" Minutos, ")
            timeSplit = minuteSplit[1]
        }
        let secondSplit = timeSplit.split("S")
        let secondValue = ""
        if (secondSplit.length > 1){
            secondValue = secondSplit[0].replace(/\D/g, "");
            secondValue = /^0*$/.test(secondValue) ? "" :  secondValue + t(" Segundos")
        }
        return yearValue + monthValue + weekValue + dayValue + hourValue + minuteValue + secondValue
    }
    
    return (
        <div>
            {!read_only ?
                <div style={{display:"flex", alignItems: "center"}}>
                    <div 
                        style={{display:"flex", width:"100%", cursor:"pointer", margin: "0px"}} 
                        onClick={() => handleConfigurationOpen(helperNode)}
                    >
                        <div style={{display: "flex",flexDirection: "column",margin: "auto 0px"}}>
                            <div className={["normalText","normalMediumSize"].join(" ")}>
                            {t("Contar variações de")} {t((variableField || {description:""}).description)} {t("para o mesmo")} {t(referencedString)}
                            </div>
                            <div className={["normalText","normalSmallSize"].join(" ")}>
                            {helperNode.node.properties.timedelta_value
                            ? t(" nos últimos ") + t(getVisualPattern(helperNode.node.properties.timedelta_value))
                            : t(" em todo o histórico")}
                            </div>
                        </div>
                        {(helperNode.node.alerts || []).length > 0?
                        <GetAlertsComponent alerts={helperNode.node.alerts} />  : null}       
                    </div>
                    <IconButton style={{width: 32, height: 32}} aria-label="duplicate" onClick={() => props.handleNodeDuplication(helperNode)}>
                        <ContentCopyIcon style={{width: 20, height: 20}} />
                    </IconButton>
                    <IconButton style={{width: 32, height: 32}} aria-label="close" onClick={() => handleNodeRemove(helperNode)}>
                        <CloseIcon style={{width: 20, height: 20}} />
                    </IconButton>
                </div>
            :
                <div style={{display:"flex"}}>
                    <div 
                        style={{display:"flex", width:"100%", cursor:"pointer", margin: "0px"}} 
                        onClick={() => handleConfigurationOpen(helperNode)}
                    >
                        <div style={{display: "flex",flexDirection: "column",margin: "auto 0px"}}>
                            <div className={["normalText","normalMediumSize"].join(" ")}>
                            {t("Contar variações de")} {t((variableField || {description:""}).description)} {t("para o mesmo")} {t(referencedString)}
                            </div>
                            <div className={["normalText","normalSmallSize"].join(" ")}>
                            {helperNode.node.properties.timedelta_value
                            ? t(" nos últimos ") + t(getVisualPattern(helperNode.node.properties.timedelta_value))
                            : t(" em todo o histórico")}
                            </div>
                        </div>   
                    </div>
                </div>
            }
        </div>
    )
}

export function EventFieldVariabilityConfiguration(props){
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
    PaperProps: {
        style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 280,
        },
    },
    };

    const { t } = useTranslation()
    let { node } = props
    let { read_only } = props
    let { handleNodeChange } = props
    let { handleConfigurationClose } = props
    let { userVariables } = props
    let rulesList = useContext(RulesContext)
    let authContext = useContext(AuthContext)
    const { isRulePiece } = rulesList
    const box_settings = rulesList.boxes[node.node.type]?.settings || {}
    let rule_company_key = (rulesList?.company_key && rulesList?.company_key !== "") ? rulesList?.company_key : authContext.user_data?.company_key
    const company = rulesList.company
    const companyList = useMemo(() => (Array.isArray(company) ? company : [company]), [company])

    const rule_event_type = useMemo(() => {
        let ruleEventType = rulesList?.event_type
        if (isRulePiece) {
            let validCompanyEvent = null
            if (isNodeV1Variability(node)) {
                const fieldPaths = (node.node.properties.referenced_field_paths || []).filter(Boolean)
                for (let comp of companyList) {
                    const companyEventCandidate = comp.company_events?.find(event =>
                        fieldPaths.every(path =>
                            event.field_mapping?.field_mappings?.some(mapping => mapping.path === path)
                        )
                    )
                    if (companyEventCandidate) {
                        validCompanyEvent = companyEventCandidate
                        break
                    }
                }
            } else {
                validCompanyEvent = companyList?.[0]?.company_events?.[0]
            }
            ruleEventType = validCompanyEvent?.field_mapping?.event_type
            ruleEventType = {
                ...ruleEventType,
                enum: RULE_PIECE_CURRENT_EVENT_ENUM,
                es_index: RULE_PIECE_CURRENT_EVENT_ES_INDEX,
                rule_company_key: RULE_PIECE_CURRENT_COMPANY_KEY,
                event_date_path: RULE_PIECE_CURRENT_EVENT_DATE_PATH
            }
        } else {
            const ruleCompany = companyList.find(comp => comp.company_key === rule_company_key)
            const ruleRegion = getRegionFromEnvironment(rulesList.environment)
            ruleEventType = ruleCompany?.company_events?.find(event =>
                event.field_mapping?.event_type?.enum === rulesList?.event_type &&
                getRegionFromEnvironment(event.field_mapping?.event_type?.environment) === ruleRegion
            )?.field_mapping?.event_type
        }
        return ruleEventType
    }, [rulesList.event_type, companyList, rule_company_key, rulesList.environment, isRulePiece, node])

    if (rule_event_type?.rule_company_key) {
        rule_company_key = rule_event_type.rule_company_key
    }

    let settingsFilters = (box_settings.filters || [])

    const [nodeState, setNodeState] = useState(() => {
        let new_node = _.cloneDeep(node)
        nodeToV2Variability(new_node)
        const target_event_type = new_node.node.properties?.target_event_type ?? rule_event_type
        if (target_event_type && !target_event_type.environment && target_event_type.region) {
            target_event_type.environment = getEnvironmentFromRegion(target_event_type.region, rulesList.environment)
        }
        new_node.node.properties.target_company_key = new_node.node.properties?.target_company_key ?? rule_company_key
        new_node.node.properties.target_event_type = target_event_type
        return new_node
    })
    const enableBusinessGroupQueryOption = (box_settings?.enable_business_group_query_option ?? false)
    const useAdvancedMode = (box_settings?.use_advanced_mode ?? false)
    const [openChangeWarning, setOpenChangeWarning] = useState(false)
    const [pendingValue, setPendingValue] = useState(null)
    const [targetFieldMapping, dispatchTargetFieldMapping] = useReducer(dataFetchReducer, {
        fetchedData: null,
        isLoading: true,
        isError: false,
    })

    const getFilteredCompany = useCallback((targetCompanyKey) => {
        const effectiveKey = targetCompanyKey || rule_company_key
        if (effectiveKey === RULE_PIECE_CURRENT_COMPANY_KEY) {
            return null
        }
        return companyList.filter((comp) =>
            effectiveKey === "every_company" || effectiveKey === comp.company_key
        )
    }, [rule_company_key, companyList])

    const getEventsForCompany = useCallback((targetCompanyKey) => {
        if (targetCompanyKey === RULE_PIECE_CURRENT_COMPANY_KEY) {
            return getEventTypesIntersectionAcrossCompanies(companyList)
        }
        const filteredCompany = getFilteredCompany(targetCompanyKey)
        if (filteredCompany == null) {
            return []
        }
        const seenEvents = new Set()
        return filteredCompany.flatMap((comp) =>
            (comp.company_events || [])
                .map(event => event.field_mapping?.event_type)
                .filter(Boolean)
                .filter(eventType => {
                    const key = `${eventType.enum}$#$${getRegionFromEnvironment(eventType.environment)}`
                    if (seenEvents.has(key)) return false
                    seenEvents.add(key)
                    return true
                })
        )
    }, [getFilteredCompany, companyList])

    const concreteCompanyEvents = useMemo(
        () => getEventsForCompany(nodeState?.node?.properties?.target_company_key) || [],
        [getEventsForCompany, nodeState.node.properties.target_company_key]
    )

    const showRulePieceNoSharedEventTypesHint =
        isRulePiece &&
        nodeState?.node?.properties?.target_company_key ===
            RULE_PIECE_CURRENT_COMPANY_KEY &&
        concreteCompanyEvents.length === 0

    const getFieldMappingObjectFromEventType = useCallback((targetCompanyKey, targetEventEnum, targetEventEnvironment) => {
        if (!targetEventEnum) return null
        const filteredCompany = getFilteredCompany(targetCompanyKey)
        if (filteredCompany == null) {
            return null
        }
        const matchingEvent = filteredCompany
            .flatMap(comp => comp.company_events || [])
            .find(event =>
                event.field_mapping?.event_type?.enum === targetEventEnum &&
                getRegionFromEnvironment(event.field_mapping?.event_type?.environment) === getRegionFromEnvironment(targetEventEnvironment)
            )
        return matchingEvent?.field_mapping ?? null
    }, [getFilteredCompany])

    const currentTargetEvent = nodeState?.node?.properties?.target_event_type ?? rule_event_type
    const currentTargetEventEnum = currentTargetEvent?.enum
    const currentTargetEventEnvironment = currentTargetEvent?.environment
    const currentTargetCompanyKey = nodeState?.node?.properties?.target_company_key
    const fieldsMapperList = useMemo(() => rulesList.fields_mapper_list || [], [rulesList])

    useEffect(() => {
        if (!currentTargetEventEnum) return
        if (currentTargetEventEnum === RULE_PIECE_CURRENT_EVENT_ENUM) {
            dispatchTargetFieldMapping({ type: "data_fetch_success", payload: { mappings: fieldsMapperList } })
            return
        }
        const targetFieldMappingObject = getFieldMappingObjectFromEventType(currentTargetCompanyKey, currentTargetEventEnum, currentTargetEventEnvironment)
        const targetFieldMappingKey = targetFieldMappingObject?.field_mapping_key
        const targetFieldMappingEnvironment = targetFieldMappingObject?.event_type?.environment
        dispatchTargetFieldMapping({ type: "data_fetch_init" })
        const timer = setTimeout(() => {
            axios
                .get(`/dash/rule_engine/event_type/${currentTargetEventEnum}/field_mapping/${targetFieldMappingKey}?environment=${targetFieldMappingEnvironment}`)
                .then((response) => {
                    dispatchTargetFieldMapping({ type: "data_fetch_success", payload: response.data })
                })
                .catch((error) => {
                    if ((error.response || {}).status === 403) dispatchTargetFieldMapping({ type: "data_fetch_failure_403" })
                    else if ((error.response || {}).status === 404) dispatchTargetFieldMapping({ type: "data_fetch_failure_404" })
                    else dispatchTargetFieldMapping({ type: "data_fetch_failure" })
                })
        }, 500)
        return () => clearTimeout(timer)
    }, [currentTargetEventEnum, currentTargetEventEnvironment, currentTargetCompanyKey, fieldsMapperList, getFieldMappingObjectFromEventType])

    const clearEventTypeInfo = (new_node) => {
        const field = new_node.node.properties.fields?.[0] || { type: "dynamic" }
        new_node.node.properties.fields = [{ ...field, target_field_path: null, comparison: null, value: null }]
    }

    const changeTargetCompanyKey = (newValue, new_node) => {
        if (newValue === "every_company") {
            setObjectByPath(new_node.node, "properties.search_with_business_group_key", true)
        } else {
            setObjectByPath(new_node.node, "properties.search_with_business_group_key", false)
        }
        const nextEvents = getEventsForCompany(newValue)
        const currentTargetEvent = nodeState?.node?.properties?.target_event_type
        if (nextEvents.length === 1) {
            setObjectByPath(new_node.node, "properties.target_event_type", nextEvents[0])
        } else {
            setObjectByPath(new_node.node, "properties.target_event_type",
                nextEvents.find(event =>
                    event.enum === currentTargetEvent?.enum &&
                    getRegionFromEnvironment(event.environment) === getRegionFromEnvironment(currentTargetEvent?.environment)
                ) || null
            )
        }
        setObjectByPath(new_node.node, "properties.target_company_key", newValue)
        setNodeState(new_node)
    }

    const handleTargetCompanyKeyChange = (e, newValue) => {
        if (areFieldsCleared(nodeState?.node?.properties?.fields)) {
            const new_node = _.cloneDeep(nodeState)
            changeTargetCompanyKey(newValue, new_node)
            return
        }
        setPendingValue({ type: "target_company_key", value: newValue })
        setOpenChangeWarning(true)
    }

    const changeTargetEventType = (newValue, new_node) => {
        setObjectByPath(new_node.node, "properties.target_event_type", newValue)
        setNodeState(new_node)
    }

    const handleTargetEventTypeChange = (e, newValue) => {
        if (areFieldsCleared(nodeState?.node?.properties?.fields)) {
            const new_node = _.cloneDeep(nodeState)
            changeTargetEventType(newValue, new_node)
            return
        }
        setPendingValue({ type: "target_event_type", value: newValue })
        setOpenChangeWarning(true)
    }

    const handleUpdateFields = (updatedFields) => {
        const new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node.properties, "fields", updatedFields)
        setNodeState(new_node)
    }

    const validateAllValues = () => {
        if (!nodeState.node.properties.target_company_key) return false
        if (!nodeState.node.properties.target_event_type) return false
        if (!nodeState.node.properties.variable_field_path || nodeState.node.properties.variable_field_path.length === 0) return false
        const fields = nodeState.node.properties.fields || []
        if (fields.length === 0) return false
        const seenFields = new Set()
        for (const field of fields) {
            const sig = `${field.target_field_path},${field.comparison},${field.value},${field.type}`
            if (seenFields.has(sig)) return false
            seenFields.add(sig)
        }
        const mappings = targetFieldMapping?.fetchedData?.mappings || nodeState.node.properties.target_event_type?.field_mappings || []
        const hasInvalidFields = fields.some(field => {
            const targetType = mappings.find(item => item.path === field.target_field_path)?.type
            return !field?.target_field_path || field?.target_field_path.length === 0 ||
                field?.comparison == null || field?.comparison === "" ||
                (field.value === undefined && field.value !== "") ||
                (field.type === "static" && targetType && !validateConstantValues(targetType, field.value))
        })
        if (hasInvalidFields) return false
        if (nodeState.node.properties.timedelta_value && !validateConstantValues("timedelta", nodeState.node.properties.timedelta_value)) return false
        return true
    }

    const handleEventChange = (e) => {
        let new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node, "properties.variable_field_path", e.target.value)
        setNodeState(new_node)
    }

    const handleValueChange = (path, val) => {
        let new_node = _.cloneDeep(nodeState)
        if (val === "P") val = null
        setObjectByPath(new_node.node, path, val)
        setNodeState(new_node)
    }

    const configurePayload = () => {
        const payload = _.cloneDeep(nodeState)
        const usedFieldPaths = new Set()
        let properties = payload.node.properties
        const fields = properties.fields || []
        fields.forEach(field => {
            if (field?.target_field_path) usedFieldPaths.add(field.target_field_path)
        })
        if (properties.variable_field_path) usedFieldPaths.add(properties.variable_field_path)
        const mappings = targetFieldMapping?.fetchedData?.mappings || []
        properties.target_event_type.field_mappings = mappings.filter(m => usedFieldPaths.has(m.path))
        const tet = properties.target_event_type
        if (
            tet?.environment === RULE_PIECE_CURRENT_EVENT_ENVIRONMENT ||
            tet?.enum === RULE_PIECE_CURRENT_EVENT_ENUM
        ) {
            tet.region = RULE_PIECE_CURRENT_EVENT_REGION
        } else if (tet?.environment != null) {
            tet.region = getRegionFromEnvironment(tet.environment)
        }
        if (tet?.environment != null) {
            delete tet.environment
        }
        delete properties.target_event_type?.description
        delete properties.target_event_type?.rule_company_key
        if (properties.search_with_business_group_key) {
            delete properties.target_company_key
        }
        properties = trimNestedObject(properties)
        if (Array.isArray(properties.fields)) {
            properties.fields = properties.fields.map(f => trimNestedObject(f))
        }
        payload.node.properties = properties
        return payload
    }

    const handleSave = () => {
        handleConfigurationClose()
        handleNodeChange(configurePayload())
    }

    const [open, setOpen] = useState(true)

    const handleClose = () => {
        handleConfigurationClose()
        setOpen(false)
    }


    const handleFilterChange = (event, path) => {
        let new_node = _.cloneDeep(nodeState)

        const { value } = event.target
        
        if(!new_node.node.properties.filters){
            new_node.node.properties.filters = {}
        }

        if(!new_node.node.properties.filters[path]){
            new_node.node.properties.filters[path] =[]
        }

        new_node.node.properties.filters[path] = value;

        if(new_node.node.properties.filters[path].length === 0){
            delete new_node.node.properties.filters[path]
        }

        if(_.size(new_node.node.properties.filters)=== 0) {
            delete new_node.node.properties.filters
        }

        setNodeState(new_node)
    };

    let options_dictionary = {}
    for(let filter of settingsFilters){
        options_dictionary[filter.path] = {};
        for(let option of filter.options){
            options_dictionary[filter.path][option.enum] = option.description
        }
    }

    let filter_rendered_values = {}
    for(let filter of settingsFilters){
        let translated_values = []
        for(let selected_option of ((nodeState.node.properties.filters||{})[filter.path]||[])){
            translated_values.push(options_dictionary[filter.path][selected_option])
        }
        filter_rendered_values[filter.path] = translated_values.join(', ')
    }


    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        minWidth: "300px",
                        maxWidth: "500px"
                    }
                }
            }}
        >
            <div style={{ flexGrow: "1", padding: "20px", display: "flex", flexDirection: "column", width: "100%", overflow: "auto", overflowX: "hidden" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span className={["blueText", "subtitleSize", "labelSpace"].join(" ")}>{t(node.node.description)}</span>
                    <Tooltip title={<div className="tooltipText"><ul>{node.node.helperText.map((help, index) => (<li key={index}>{t(help)}</li>))}</ul></div>}>
                        <HelpIcon style={{ fontSize: "14px", display: "flex", margin: "auto 5px" }} />
                    </Tooltip>
                </div>

                {nodeState && useAdvancedMode && (
                    <div style={{ marginBottom: "24px" }}>
                        <HistoricalDataPicker
                            targetCompanyKey={nodeState.node.properties?.target_company_key}
                            targetEventType={nodeState.node.properties?.target_event_type}
                            companyList={companyList}
                            companyEvents={concreteCompanyEvents}
                            ruleEventType={rule_event_type}
                            isRulePiece={isRulePiece}
                            readOnly={read_only}
                            enableBusinessGroupQueryOption={enableBusinessGroupQueryOption}
                            onCompanyKeyChange={handleTargetCompanyKeyChange}
                            onEventTypeChange={handleTargetEventTypeChange}
                            showRulePieceNoSharedEventTypesHint={showRulePieceNoSharedEventTypesHint}
                        />
                    </div>
                )}

                <div className="internalCardContainer" style={{ display: "flex", flexDirection: "column", margin: "12px 0", width: "100%" }}>
                    {nodeState && (
                        <>
                            <p className={["blueText", "subtitleSize"].join(" ")} style={{ width: "100%", margin: "0" }}>
                                {t("Campo a variar")}
                            </p>
                            <TextField
                                label={t("Campo Variado")}
                                style={{ textAlign: "center", width: "100%", margin: "12px 0 16px 0" }}
                                error={!nodeState.node.properties.variable_field_path}
                                className="filterTextbox"
                                size="small"
                                fullWidth
                                value={nodeState.node.properties.variable_field_path || ""}
                                onChange={handleEventChange}
                                select
                                InputProps={{ readOnly: read_only }}
                            >
                                {(() => {
                                    const mappings = targetFieldMapping?.fetchedData?.mappings || nodeState.node.properties.target_event_type?.field_mappings || rulesList.fields_mapper_list || []
                                    return mappings.map((field, index) => (
                                        <MenuItem key={index} value={field.path}><em className="normalText">{t(field.description) + " (" + t(translateType(field.type)) + ")"}</em></MenuItem>
                                    ))
                                })()}
                            </TextField>
                        </>
                    )}
                    <FieldsManager
                        read_only={read_only}
                        fields={nodeState.node.properties.fields || []}
                        onUpdate={handleUpdateFields}
                        rulesList={rulesList}
                        fieldMapping={targetFieldMapping}
                        userVariables={userVariables}
                        useAdvancedMode={useAdvancedMode}
                        sectionTitle={t("Referências")}
                    />
                    <p className={["blueText", "subtitleSize"].join(" ")} style={{ width: "100%", margin: "0", marginTop: "12px" }}>{t("Configurações")}</p>
                    {settingsFilters.map(filter =>
                        <FormControl key={filter.path} style={{ textAlign: "center", width: "100%", margin: "0 auto 12px auto" }}>
                            <InputLabel id="demo-multiple-checkbox-label">{t(filter.description)}</InputLabel>
                            <br></br>
                            <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                value={((nodeState.node.properties.filters || {})[filter.path] || [])}
                                onChange={(event) => handleFilterChange(event, filter.path)}
                                input={<Input />}
                                renderValue={() => (filter_rendered_values[filter.path])}
                                MenuProps={MenuProps}
                                InputProps={{ readOnly: read_only }}
                            >
                                {[...(filter.options || [])].sort((a, b) => (a.description || "").localeCompare(b.description || "")).map((option) => (
                                    <MenuItem key={option.enum} value={option.enum} name={option.description}>
                                        <Checkbox color="primary" checked={((nodeState.node.properties.filters || {})[filter.path] || []).includes(option.enum)} />
                                        <ListItemText primary={t(option.description)} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                    <TimeDeltaTextField
                        value={nodeState.node.properties.timedelta_value ? nodeState.node.properties.timedelta_value : ""}
                        error={nodeState.node.properties.timedelta_value ? !validateConstantValues("timedelta", nodeState.node.properties.timedelta_value) : false}
                        valueChangeFunction={(value) => handleValueChange("properties.timedelta_value", value)}
                        label={t("Período de Tempo considerado")}
                        read_only={read_only}
                    />
                </div>
                <div style={{ display: "flex" }}>
                    <div
                        className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                        style={{ width: "50%" }}
                        onClick={handleClose}
                    >
                        {read_only ? "X" : t("discard")}
                    </div>
                    {!read_only &&
                        <div
                            className={
                                validateAllValues()
                                    ? ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                                    : ["button", "standard", "normalText", "normalMediumSize", "disabled"].join(" ")}
                            style={{ width: "50%" }}
                            onClick={validateAllValues() ? handleSave : null}
                        >
                            {t("save")}
                        </div>}
                </div>
            </div>
            {openChangeWarning && pendingValue && (
                <Dialog
                    open={openChangeWarning}
                    onClose={() => {
                        setOpenChangeWarning(false)
                        setPendingValue(null)
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                        "& .MuiDialog-container": {
                            "& .MuiPaper-root": {
                                width: "100%",
                                minWidth: "250px",
                                maxWidth: "350px"
                            }
                        }
                    }}
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Alterar o tipo de evento limpará os campos configurados")}
                    </DialogTitle>
                    <DialogContent>
                        <Typography id="alert-dialog-description">
                            {t("Deseja continuar?")}
                        </Typography>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", padding: "16px 24px", width: "100%" }}>
                        <div
                            className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                            style={{ width: "50%" }}
                            onClick={() => {
                                setOpenChangeWarning(false)
                                setPendingValue(null)
                            }}
                        >
                            {t("Não")}
                        </div>
                        <div
                            className={["button", "standard", "normalText", "normalMediumSize"].join(" ")}
                            style={{ width: "50%" }}
                            onClick={() => {
                                const new_node = _.cloneDeep(nodeState)
                                clearEventTypeInfo(new_node)
                                if (pendingValue.type === "target_company_key") {
                                    changeTargetCompanyKey(pendingValue.value, new_node)
                                } else if (pendingValue.type === "target_event_type") {
                                    changeTargetEventType(pendingValue.value, new_node)
                                }
                                setOpenChangeWarning(false)
                                setPendingValue(null)
                            }}
                        >
                            {t("Sim")}
                        </div>
                    </DialogActions>
                </Dialog>
            )}
        </Dialog>
    )
}

export class EventFieldVariabilityBoxClass {
    constructor(rulesContext) {
        this.rulesContext = rulesContext
    }
    validate(node) {
        let put_error = false
        let alerts = []
        const isV1 = isNodeV1Variability(node)
        const validateNode = _.cloneDeep(node)
        nodeToV2Variability(validateNode)
        const props = validateNode.node.properties
        const mappings =
            props.target_event_type?.field_mappings ||
            this.rulesContext?.fields_mapper_list ||
            []

        if ((validateNode.node.children || []).length !== 0) {
            put_error = true
            alerts.push("Este nó não deve possuir filhos")
        }
        if (!isV1) {
            if (!props.target_company_key) {
                put_error = true
                alerts.push("Este nó deve ter uma base histórica (cliente) selecionada")
            }
            if (!props.target_event_type) {
                put_error = true
                alerts.push("Este nó deve ter um tipo de evento selecionado")
            }
        }
        if (!props.variable_field_path || props.variable_field_path.length === 0) {
            put_error = true
            alerts.push("Clique neste nó, abra a configuração e escolha um Campo Variado")
        } else {
            if (mappings.length > 0) {
                const variableMapping = mappings.find(
                    m => m.path === props.variable_field_path
                )
                if (!variableMapping) {
                    put_error = true
                    alerts.push(
                        "O Campo Variado deve existir no tipo de evento selecionado"
                    )
                }
            }
        }
        const fields = props.fields || []
        if (fields.length === 0) {
            put_error = true
            alerts.push("Este nó deve ter pelo menos uma referência configurada")
        } else {
            const seen = new Set()
            for (const field of fields) {
                const sig = `${field.target_field_path},${field.comparison},${field.value ?? ""},${field.type ?? ""}`
                if (seen.has(sig)) {
                    put_error = true
                    alerts.push("Este nó não deve ter referências duplicadas")
                    break
                }
                seen.add(sig)
            }
            if (mappings.length > 0) {
                const hasInvalid = fields.some(f => {
                    if (!f?.target_field_path || f.target_field_path.length === 0) return true
                    if (f.comparison == null || f.comparison === "") return true
                    const mapping = mappings.find(m => m.path === f.target_field_path)
                    if (!mapping) return true
                    if (
                        f.type === "static" &&
                        f.value !== undefined &&
                        f.value !== "" &&
                        !validateConstantValues(mapping.type, f.value)
                    ) {
                        return true
                    }
                    return false
                })
                if (hasInvalid) {
                    put_error = true
                    alerts.push(
                        "Todas as referências devem ter campo, comparação e valor válidos"
                    )
                }
            }
        }
        if (props.timedelta_value && !validateConstantValues("timedelta", props.timedelta_value)) {
            put_error = true
            alerts.push("Deve ser fornecido um período de tempo válido")
        }
        if (node.parentNode != null && node.parentNode.on_error) {
            put_error = true
            alerts.push("O nó superior está inválido")
        }
        return { validated: !put_error, alerts }
    }

    getType(node) {
        return "number"
    }
}
